@if (isStatusOpen) {
  <div class="dropdown-overlay" (click)="closeModal()"></div>
  <div class="sort-container">
    <div class="sort-item" *ngFor="let item of sortingTypeDictionary" (click)="toggleModal(item)">
      <div class="text">
        <span>{{ item.name! | translate }}</span>
      </div>
    </div>
  </div>
}
<div class="button-wrapper">
  <div class="button" (click)="toggleModal()">
    <div class="button-text">
      <span>{{ title | translate }}</span>
    </div>
    <div class="sort-type">
      <span >
        {{ selectedOption | translate }}
      </span>
    </div>
    <div><img alt="Status" src="assets/core/table-button/sort.svg" /></div>
  </div>
</div>